import React from 'react';
import '../styles/MotorGrader.css';

const MotorGrader = () => {
  return (
    <section className="motor-grader">
      <div className="grader-container">
        <div className="grader-text">
          <h2 className="grader-title">NIVELEUSE</h2>
          <h3 className="grader-model">CLG4215D</h3>
          <p className="grader-tagline">" Niveler le terrain, élever vos projets "</p>
          
          <div className="grader-description">
            <p>
              La LiuGong 4215D est une niveleuse puissante et précise, idéale pour les
              travaux BTP exigeants. Performante, fiable et confortable, elle maximise
              votre productivité sur tous types de chantiers.
            </p>
          </div>
          
          <a href="/products/grader" className="grader-button">
            NOS NIVELEUSE
          </a>
        </div>
        
        <div className="grader-image">
          <img 
            src="/assets/images/niveleuse.png" 
            alt="Niveleuse LiuGong CLG4215D" 
          />
        </div>
      </div>
    </section>
  );
};

export default MotorGrader;